import { ModuleModel } from '../../module.model.interface';
import { FormDescriptor } from '../../form/model/form';
import { OrganizationModel } from '../../organization/model/organization.model';
import { ProfileModel } from '../../profile/model/profile.model';
import { LabelDescriptor } from '../../label/model/label';

export enum BulletinState {
  Created,
  SentToClient,
  Closed
}

export class BulletinStateDetail {
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const BulletinStateMap = {
  Created: new BulletinStateDetail({ id: 'Created', name: 'Létrehozva' }),
  SentToClient: new BulletinStateDetail({ id: 'SentToClient', name: 'Publikálva' }) //,
//  Closed: new BulletinStateDetail({ id: 'Closed', name: 'Lezárva' })
};

export const BulletinStateList: BulletinStateDetail[] = [
  BulletinStateMap.Created,
  BulletinStateMap.SentToClient //,
  //BulletinStateMap.Closed,
];

export class BulletinDescriptor implements ModuleModel {
  public discriminator = 'BulletinDescriptor';

  public id: string;
  public name: string;
  public organizationId: string;
  public formId: string;
  public labelId: string;
  public periodStart: Date;
  public bulletinState: BulletinState;
  public createdBy: string;
  public createdOn: Date;
  public assignedTo: string;
  public responsible: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public formDetail?: FormDescriptor;
  public formTitle?: string;
  public organizationDetail?: OrganizationModel;
  public organizationTitle?: string;
  public labelDetail?: LabelDescriptor;
  public labelName?: string;
  public assignedDetail?: ProfileModel;
  public assignedFullName?: string;
  public responsibleDetail?: ProfileModel;
  public responsibleFullName?: string;

  constructor(options?: {
    id: string;

    name: string;
    organizationId: string;
    formId: string;
    labelId: string;
    periodStart: Date;
    bulletinState: BulletinState;
    createdBy: string;
    createdOn: Date;
    assignedTo: string;
    responsible: string;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;

      this.name = options.name;
      this.organizationId = options.organizationId;
      this.formId = options.formId;
      this.labelId = options.labelId;
      this.periodStart = options.periodStart;
      this.bulletinState = options.bulletinState;
      this.createdBy = options.createdBy;
      this.createdOn = options.createdOn;
      this.assignedTo = options.assignedTo;
      this.responsible = options.responsible;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }

  }
}

export enum BulletinMachineAttributeName {
  Message,
  Justification
}

export class BulletinMachineAttribute {
  public name: BulletinMachineAttributeName;
  public value: string;

  constructor(options?: {
    name: BulletinMachineAttributeName;
    value: string;
  }) {

    if (options) {
      this.name = options.name;
      this.value = options.value;
    }
  }
}

export enum BulletinMachineCommand {
  SendToClient,
  Close
}

export const BulletinMachineCommandMessage = {
  SendToClient: { done: 'A közlemény küldése sikeresen megtörtént.', fail: 'A közlemény küldése nem sikerült.' },
  Close: { done: 'A közlemény lezárása sikeresen megtörtént.', fail: 'A közlemény lezárása nem sikerült.' }
};

export class BulletinMachineStateDescriptor implements ModuleModel {
  public discriminator = 'BulletinMachineStateDescriptor';

  public command?: BulletinMachineCommand;
  public attributes?: BulletinMachineAttribute[];

  constructor(options?: {
    command?: BulletinMachineCommand;
    attributes?: BulletinMachineAttribute[];
  }) {

    if (options) {
      this.command = options.command;
      this.attributes = options.attributes;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/bulletin/model/bulletin.ts